<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="invoice_is_load" parent="invoice">
    <tab id="info" :name="translate('invoice.section.info')" :href="url+'/info'">
      <InvoiceInfo v-if="invoice_is_load"
        :invoice="invoice_info"
        @update="request_invoice"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              ClientInvoice: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/invoice_list'}">
              To ClientInvoice list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import InvoiceInfo from './Tabs/Info/Index.vue'

export default {
  name: 'Invoice',
  components: {
    InvoiceInfo,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      invoice_info: null,
      timer: null,
    }
  },

  computed: {
    url () { return '/invoice/' + this.$route.params.invoice_id },
    cur_id () { return this.$route.params.invoice_id },
    load () { return !this.invoice_info?.id },
    invoice_is_load() { return this.invoice_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'invoice_section') {
        this.invoice_info = null
        this.$store.commit('updateSelectedInvoice', null)
        this.request_invoice()
      }
    }
  },

  activated(){
    this.invoice_info = null
    this.$store.commit('updateSelectedInvoice', null)
    this.request_invoice()
  },

  deactivated() {
    clearTimeout(this.timer)
    this.timer = null
    this.invoice_info = null
    this.$store.commit('updateSelectedInvoice', null)
  },

  methods: {
    request_invoice () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_invoice, 500)
    },
    get_invoice () {
      let id = this.cur_id
      if (!id || this.$route.name !== 'invoice_section') return
      this.$http.v1.getInvoice(id, (response) => {
        if (id !== this.cur_id || this.$route.name !== 'invoice_section') return
        this.invoice_info = response.data
        this.$store.commit('updateSelectedInvoice', response.data)
      })
    }
  }
}

</script>
